// extracted by mini-css-extract-plugin
module.exports = {"itemForm":"ItemForm_itemForm__kNxhA","error":"ItemForm_error__2w9nj"};